import { render } from "./EventItemQuestionsPage.vue?vue&type=template&id=155ebb17&scoped=true"
import script from "./EventItemQuestionsPage.vue?vue&type=script&lang=js"
export * from "./EventItemQuestionsPage.vue?vue&type=script&lang=js"

import "./EventItemQuestionsPage.vue?vue&type=style&index=0&id=155ebb17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155ebb17"]])

export default __exports__